interface Benefit {
  icon: string;
  text: string;
}

interface AuthPageMeta {
  title: string;
  backgroundImage: string;
  benefits: Benefit[];
}

export const authPageMeta: Record<string, AuthPageMeta> = {
  signup: {
    title: "Transform Your Corporate Gifting with AI-Powered Solutions",
    backgroundImage:
      "https://images.pexels.com/photos/7123111/pexels-photo-7123111.jpeg?auto=compress&cs=tinysrgb&w=600",
    benefits: [
      { icon: "las la-brain", text: "AI Expert Understands Your Vision" },
      { icon: "las la-magic", text: "Instant Mockup & Catalog Generation" },
      { icon: "las la-chart-line", text: "Bulk Enquiry Management Tools" },
      { icon: "las la-heart", text: "Emotion-Driven Gift Recommendations" },
    ],
  },
  login: {
    title: "Welcome Back to Intelligent Corporate Gifting",
    backgroundImage:
      "https://images.pexels.com/photos/3183198/pexels-photo-3183198.jpeg?auto=compress&cs=tinysrgb&w=600",
    benefits: [
      { icon: "las la-robot", text: "Access Your AI Gifting Assistant" },
      { icon: "las la-palette", text: "Resume Custom Mockup Projects" },
      { icon: "las la-users", text: "Manage Your Corporate Campaigns" },
      { icon: "las la-chart-bar", text: "Track Gifting Impact & ROI" },
    ],
  },
  forgot: {
    title: "Recover Access to Your Gifting Command Center",
    backgroundImage:
      "https://images.pexels.com/photos/3823488/pexels-photo-3823488.jpeg?auto=compress&cs=tinysrgb&w=600",
    benefits: [
      { icon: "las la-route", text: "Simple Recovery Process" },
      { icon: "las la-envelope-open", text: "Secure Email Verification" },
      { icon: "las la-shield-alt", text: "Protected Account Recovery" },
      { icon: "las la-clock", text: "Quick Access Restoration" },
    ],
  },
  reset: {
    title: "Secure Your Corporate Gifting Platform",
    backgroundImage:
      "https://images.pexels.com/photos/3184465/pexels-photo-3184465.jpeg?auto=compress&cs=tinysrgb&w=600",
    benefits: [
      { icon: "las la-key", text: "Enterprise-Grade Security Standards" },
      { icon: "las la-lock", text: "Protect Your Business Data" },
      { icon: "las la-shield-virus", text: "Advanced Threat Protection" },
      { icon: "las la-check-double", text: "Immediate Secure Access" },
    ],
  },
  verify: {
    title: "Activate Your Corporate Gifting Account",
    backgroundImage:
      "https://images.pexels.com/photos/3184292/pexels-photo-3184292.jpeg?auto=compress&cs=tinysrgb&w=600",
    benefits: [
      { icon: "las la-certificate", text: "Verify Business Email Domain" },
      { icon: "las la-rocket", text: "Unlock AI-Powered Features" },
      { icon: "las la-gift", text: "Access Premium Gifting Catalog" },
      { icon: "las la-handshake", text: "Join Corporate Partner Network" },
    ],
  },
  change: {
    title: "Strengthen Your Platform Security",
    backgroundImage:
      "https://images.pexels.com/photos/5380649/pexels-photo-5380649.jpeg?auto=compress&cs=tinysrgb&w=600",
    benefits: [
      { icon: "las la-user-shield", text: "Protect Corporate Data" },
      { icon: "las la-fingerprint", text: "Enhanced Authentication" },
      { icon: "las la-building", text: "Enterprise Compliance Ready" },
      { icon: "las la-history", text: "Regular Security Updates" },
    ],
  },
};
